import { Notifications } from '@leprecoins/notifications';
import { PropsWithChildren } from 'react';
import { useScaleNotifications } from 'entities/game';
import { createComposableProvider } from 'shared/lib';
import '@leprecoins/notifications/style.css';
import 'shared/ui/notifications/notifications.scss';

export const NotificationsProvider = ({ children }: PropsWithChildren) => {
	useScaleNotifications();

	return (
		<>
			{children}
			<Notifications />
		</>
	);
};

export const withNotifications = createComposableProvider(NotificationsProvider);
